var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import { URLSearchParams } from '@angular/http';
import { Angulartics2 } from 'angulartics2';
import Munchkin from './munchkin';
var Angulartics2Marketo = /** @class */ (function () {
    function Angulartics2Marketo(_angulartics2) {
        var _this = this;
        this._angulartics2 = _angulartics2;
        this._angulartics2.pageTrack.subscribe(function (event) { return _this._pageTrack(event); });
        this._angulartics2.eventTrack.subscribe(function (event) { return _this._eventTrack(event); });
        this._angulartics2.setUsername.subscribe(function (x) { return _this._setUsername(x); });
    }
    Angulartics2Marketo.prototype._pageTrack = function (_a) {
        var path = _a.path;
        Munchkin.visitWebPage(path);
    };
    Angulartics2Marketo.prototype._eventTrack = function (_a) {
        var action = _a.action, properties = _a.properties;
        var e_1, _b;
        properties = Object.assign({}, properties);
        var path = properties.path;
        delete properties.path;
        var params = new URLSearchParams();
        try {
            for (var _c = __values(Object.keys(properties)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var key = _d.value;
                var value = properties[key];
                params.set(key, value);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (properties.label === 'visit') {
            Munchkin.visitWebPage(action, params.toString());
        }
        if (properties.eventType === 'click') {
            Munchkin.clickLink(action, params.toString());
        }
        else {
            Munchkin.visitWebPage(path, params.toString());
        }
    };
    Angulartics2Marketo.prototype._setUsername = function (email) {
        if (email === null) {
            Munchkin.logout();
        }
    };
    return Angulartics2Marketo;
}());
export { Angulartics2Marketo };
